export enum RunMode {
  DemoMode = 'Front End Running In Isolation With Dummy Data',
  LocalMode = 'Running local with a local instance of transaction-service_v2',
  Production = 'Everything Is Real'
}
